import { ICompileProvider } from 'angular';


function compileConfig($compileProvider: ICompileProvider): void {
    $compileProvider.debugInfoEnabled(false);
}

compileConfig.$inject = ['$compileProvider'];

export { compileConfig };
